export default __webpack_public_path__ + "static/media/attractions4.dc263586.png";